<template>
  <van-popup v-model="open" position="bottom" closeable style="height: 80vh;" :safe-area-inset-bottom="true">
    <div style="padding: 20px; height: 100%; overflow-y: auto;">
      <h3 style="text-align: center; margin-bottom: 20px;">添加语音</h3>

      <van-field
        v-model="content"
        rows="6"
        type="textarea"
        placeholder="请输入要识别的内容"
        maxlength="500"
        show-word-limit
      />

      <div style="margin: 20px 0; text-align: center;">
        <van-button
          type="primary"
          @click="textChange"
          :loading="identify"
        >
          {{ identify ? '识别中...' : '开始识别' }}
        </van-button>
      </div>

      <div v-if="identifyTip" style="font-size: 12px; color: #ee0a24; margin-bottom: 10px;">
        {{ identifyTip }}
      </div>

      <div v-if="voiceLink" style="margin-top: 20px;">
        <p style="margin-bottom: 10px; font-weight: 500;">识别结果（可播放）：</p>
        <audio controls style="width: 100%;" :src="voiceLink" />
        <div style="margin-top: 10px; text-align: center;">
          <van-button
            type="primary"
            size="small"
            icon="download"
            @click="downloadFileWithAuth"
          >
            下载音频
          </van-button>
        </div>
      </div>

      <div v-else style="margin-top: 20px;">
        <van-empty description="暂无识别结果" />
      </div>

      <div style="margin-top: 30px;">
        <van-button type="info" size="large" @click="submitForm" block>提交保存</van-button>
        <van-button size="large" @click="cancel" style="margin-top: 10px;" block>取消</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { speechSynthesis, addVoiceSynthesis } from "@/api/index";
import axios from "axios";
export default {
  data() {
    return {
      open: false,
      content: '',
      voiceLink: '',
      identify: false,
      identifyTip: '',
      userId: '',
      userName: '',
      platForm: ''
    };
  },
  methods: {
    openDialog() {
      this.open = true;
      this.reset();
    },
    textChange() {
      if (!this.content.trim()) {
        this.$toast('请输入内容');
        return;
      }
      this.identify = true;
      this.identifyTip = '语音生成中，请稍候...';

      speechSynthesis({ text: this.content }).then(response => {
        const data = response.data?.data;
        if (data) {
          this.voiceLink = data;
          this.$toast.success('识别成功');
        } else {
          this.$toast.fail('未返回音频链接');
        }
      }).catch(err => {
        this.$toast.fail('识别失败');
        console.error(err);
      }).finally(() => {
        this.identify = false;
        this.identifyTip = '';
      });
    },
    submitForm() {
      if (!this.voiceLink) {
        this.$toast('请先生成语音');
        return;
      }
      const data = {
        content: this.content,
        voiceLink: this.voiceLink,
        userId: this.userId,
        userName: this.userName,
        platForm: this.platForm,
        type: 1
      };
      addVoiceSynthesis(data).then(() => {
        this.$toast.success('新增成功');
        this.open = false;
        this.$emit('ok');
      }).catch(() => {
        this.$toast.fail('保存失败');
      });
    },
   async downloadFileWithAuth(voiceLink) {
      const fileUrl = voiceLink; // 需要认证的 URL
      const fileName = "audio.mp3"; // 你期望的文件名

      try {
        // 使用 axios 请求文件，responseType 设置为 'blob'
        const response = await axios.get(fileUrl, {
          responseType: "blob", // 关键：告诉 axios 将响应作为二进制大对象处理
          headers: {
            // 如果需要认证，添加请求头
            // 'Authorization': 'Bearer your-jwt-token-here'
            // 其他可能的头...
          },
        });
        console.log(response);
        // 检查响应状态
        if (response.status === 200) {
          // 创建一个 Blob URL
          const blob = new Blob([response.data], { type: response.data.type });
          console.log(blob);
          const url = window.URL.createObjectURL(blob);
          console.log(url);
          // 创建一个临时的 <a> 标签来触发下载
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName; // 设置下载的文件名
          document.body.appendChild(link);
          link.click();

          // 清理：移除元素并释放 Blob URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.$modal.msgSuccess("下载成功");
        } else {
          console.error("下载失败:", response.statusText);
        }
      } catch (error) {
        console.error("下载过程中出错:", error);
        // 处理错误，例如显示错误消息
      }
    },
    reset() {
      this.content = '';
      this.voiceLink = '';
      this.identify = false;
      this.identifyTip = '';
    },
    cancel() {
      this.open = false;
      this.reset();
    }
  }
};
</script>